import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { Router, ActivatedRoute } from '@angular/router';
import {
  IcecontrolSettings,
  iceColumnDefinition,
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { subscriberindex } from '../../../../icemedx-lib/src/models/domain/subscriberindex';
import { BasesearchComponent } from '../basesearch.component';
import { patientindex } from '../../../../icemedx-lib/src/models/domain/patientindex';

@Component({
  selector: 'app-patientsearch',
  templateUrl: './patientsearch.component.html',
  styleUrls: ['./patientsearch.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class PatientsearchComponent extends BasesearchComponent implements OnInit {

  constructor(appSvc: AppService,
    loginSvc: LoginService,
    navSvc: IceNavService,
    router: Router,
    domSvc: DomainService,
    ptSvc: PatientService,
    activatedRoute: ActivatedRoute) {
    super(appSvc, loginSvc, navSvc, router, domSvc, ptSvc, activatedRoute, "Patient search");
  }

  doSearch(keyword: string) {
    this.getPatientService().getPatientsByKeyword(this.getAppService().getCurrentAccountType(), this.getAppService().getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, keyword).subscribe(
      data => {
        if (data && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            let sobj: patientindex = <patientindex>data[0];
            if (sobj == null) continue;
            var dob_utc = sobj["dob_utc"];
            sobj.dob = Iceutility.getDateTextEx(dob_utc != null && dob_utc.length > 0 ? dob_utc : Iceutility.ConvertFromDotNetServerTime(sobj.dob));
          }
          this.refreshTableData(data);
        }
        else {
          this.refreshTableData([]);
        }
      },
      error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.getPatientService().getLastErrors()));
      });
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("title", "Title", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("first_name", "First name", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("last_name", "Last name", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("dob", "Date of Birth", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("sex", "Gender", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("additional_name", "Other name", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("communication_number1", "Contact 1", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("communication_number2", "Contact 2", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("trans_account", "trans_account", true),
    ];
  }

  onButtonClick(event) {
    debugger;
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        default: {
          break;
        }
      }
    }
  }

  onControlChange(event) {
    debugger;
  }

  onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        default: {
          this.getRouter().navigate([this.getNavService().buildRoute("pharmacy/addpatient/", false)]);
          break;
        }
      }
    }
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    if (event.actionItem == null) return;
    if (IceTypes.recordQuickActionView.value == event.actionItem.value) {
      //let doc = <externaldata>event["rowData"];
      //if (doc == null) {
      //  // To do log error
      //  return;
      //}
      //this.payerService.downloadDocument("payers", this.getAppService().getCurrentAccount(), event.rowData.external_data_key, event.rowData.parent_src_type);
    }
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      this.getDomainService().logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while downloading the document.");
      return;
    }

    // fall through, for now
  }
}
